import store from '../../state/store.js';
import { context } from 'shared/setup/WhitelabelContext.jsx';
import mountWhitelabelApp from 'shared/setup/mountWhitelabelApp.jsx';

import common from 'sharedAssets/locale/sv/common.json';
import search from 'sharedAssets/locale/sv/search.json';

import SearchPage from '../../SearchPage.jsx';

mountWhitelabelApp(
    store,
    {
        lng: 'sv',
        fallbackLng: 'sv',
        resources: {
            sv: { common, search },
        },
        defaultNS: 'search',
    },
    context.blocket,
    SearchPage,
    'flightSearchApp'
);

if (module.hot) {
    module.hot.accept();
}
